import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/

.badge {
  display: flex; //was inline-flex but absolute positioning gets weird
  margin: 0;
  align-items: center;
  border-radius: var(--p-badge-radius, 4px);
  font-style: normal;
  text-transform: uppercase;
  padding: 0.3rem;
  height: calc(var(--p-font-size-smallest) * 2);
  line-height: 1;
  letter-spacing: 0.05em;
  gap: 6px;
}

/**
--------------------------------------------------
* Color
--------------------------------------------------
*/
.light-grey {
  background-color: var(--p-bg-light);
  color: #444;
  border: 1px solid rgba(0,0,0,0.08);
}

.dashed {
  border: 1px dashed rgba(0,0,0, var(--p-text-meta-opacity));
  background-color: var(--p-bg);
}

.primary {
  background-color: var(--p-brand);
  color: var(--p-brand-contrast);
}

:host([dark]) .light-grey {
  background-color: var(--p-bg-dark);
  border: 1px solid var(--p-text-color-light-contrast-300);
  color: var(--p-text-color-light);

}


:host([dark]) .dashed {
  border: 1px dashed var(--p-text-color-light);
  color: var(--p-text-color-light);
  background-color: transparent;
  /* background-color: var(--p-bg-dark); */
}

.live {
  background-color: var(--p-bg);
  border: 1px solid var(--p-border);
}

:host([dark]) .live {
  background-color: var(--p-bg-dark);
  border: 1px solid var(--p-text-color-light-contrast-300);
  color: var(--p-text-color-light);
}

.live .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--p-live);
  position: relative;
}

.live .dot::before,
.live .dot::after {
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  background-color: var(--p-live);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  opacity: 0.2;
  transform: translate(-50%, -50%) scale(0);
  animation: 1.8s ease-in-out 0s infinite normal none running pulse;
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(0);
    border-radius: 50%;
    opacity: 0.7;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(4);
  }
}

@media (prefers-reduced-motion) {
  .live .dot::before,
  .live .dot::after {
    animation: none;
  }
}

/**
--------------------------------------------------
* Sizes
--------------------------------------------------
*/
.small {
  font-size: var(--p-font-size-smallest);
}
.medium {
  font-size: var(--p-font-size-small);
}
.large {
  font-size: var(--p-font-size-normal);
}


`;
